import { Injectable } from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime, filter, tap } from 'rxjs/operators';
import { LcsSingleSelectDirective } from './single-select.directive';

@Injectable({ providedIn: 'root' })
export class LcsSingleSelectInputService {
   getObservables(
      trigger: LcsSingleSelectDirective<any>,
      element: HTMLInputElement,
      search: (searchTerm: string | null | undefined) => void,
      searchReset: () => void
   ) {
      // The 'closed' event emitter used below only emits when the panel visually opens and closes,
      // not when the overlay attaches and detaches. So, if a panelClosingAction fires while the
      // panel is visually hidden, our 'closed' subscription won't fire. This subscription covers
      // that case.
      const blur = fromEvent<never>(element, 'blur').pipe(
         filter(() => {
            return !trigger.panelOpen;
         }),
         tap(searchReset)
      );

      const closed = trigger.singleSelect.closed.pipe(tap(searchReset));

      const input = fromEvent<never>(element, 'input').pipe(
         debounceTime(75),
         tap(() => {
            search(this.formatSearchText(element.value));
         })
      );

      return { blur, closed, input };
   }

   private formatSearchText(searchText: string | null | undefined): string | null | undefined {
      return searchText ? searchText.replace(/\\/g, '') : searchText;
   }
}
